module.exports = __webpack_public_path__ + "img/reason18.22d7611c.png";